// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/New-Products/new/sebosal-FaceWash.jpeg";
import thumb1 from "../assets/images/allproducts/Sebosal.jpg";
import thumb2 from "../assets/images/New-Products/new/sebosal-FaceWash.jpeg";
import thumb3 from "../assets/images/All-Products/Sebosal.png";
import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";



const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Skin Care", to: "/Skin-Care-Products" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb1 ,thumb2].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>Sebosal </h2>
              <p className="sub-heading text-muted">Fight Acne, Without Dryness: Perfect for Oily Skin. </p>
              <h5>Product Overview</h5>
              <p>
                Sebosal facewash is exclusively designed for reducing acne breakouts in oily and acne prone skin.
                It is a comprehensive solution for removing excess oil without drying. It controls P.
                Acne (bacteria causing acne) and cleans debris.
              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">Sebosal?</span>
                </h3>
                <p>
                  Rub it gently on your face & allow it to stay for a minute,	Avoid contact with eyes
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "application", "ingredients"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "application"
                      ? "APPLICATION GUIDELINES"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <ul>
                    <li>Purifies skin using Sepicontrol-A5.</li>
                    <li>Prevents dryness with Aloe Vera.</li>
                    <li>Zinc PCA controls sebum secretion and reduces acne.</li>
                    <li>Mild and deep pore cleanser that relieves acne and breakouts.</li>
                    <li>Gives a clean and clear look by cleansing impurities and excess oil from the skin.</li>
                    <li>Salicylic acid along with Zinc PCA helps reduce whiteheads and blackheads.</li>
                    <li>Hypoallergenic, non-comedogenic, and non-irritating facewash.</li>
                  </ul>

                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ol>
                      <li>Take a small amount of Sebosal facewash on your palms.</li>
                      <li>Rub it gently on your face and allow it to stay for a minute.</li>
                      <li>Cleans with water.</li>
                      <li>Avoid contact with eyes.</li>
                    </ol>

                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li><strong>Sepicontrol A5:</strong> Aminovector™ solution combining glycine (a skin purifier) and cinnamon bark extract (astringent). It is a dermo-protecting and purifying ingredient that restores balance to acne-prone oily skin by reducing blackheads and sebum levels. It also lowers inflammatory cytokines like Interleukin-1 alpha and controls hyperkeratinization.</li>
                      <li><strong>Salicylic acid:</strong> Controls sebum secretion and significantly reduces acne lesion count.</li>
                      <li><strong>Zinc PCA:</strong> Reduces sebum production and inflammation caused by acne; shows antibacterial activity against *P. acnes*.</li>
                      <li><strong>Aloe vera extract:</strong> Removes excess oil, hydrates the skin, and prevents acne breakouts.</li>
                    </ul>


                  </p>
                </div>
              )}



            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
